var map = {
	"./sound_cats_christmastree.wav": [
		111,
		3
	],
	"./sound_cats_jinglebells.wav": [
		112,
		4
	],
	"./sound_cats_silentnight.wav": [
		113,
		5
	],
	"./sound_christmastree.wav": [
		39
	],
	"./sound_click.wav": [
		114,
		6
	],
	"./sound_cover.wav": [
		115,
		7
	],
	"./sound_jinglebells.wav": [
		38
	],
	"./sound_pair.wav": [
		116,
		8
	],
	"./sound_pairNumber.wav": [
		117,
		9
	],
	"./sound_silentnight.wav": [
		40
	],
	"./sound_spawn_001.wav": [
		118,
		10
	],
	"./sound_spawn_002.wav": [
		119,
		11
	],
	"./sound_spawn_003.wav": [
		120,
		12
	],
	"./sound_transition.wav": [
		37
	],
	"./sound_uncover.wav": [
		121,
		13
	],
	"./sound_win.wav": [
		122,
		14
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 60;
module.exports = webpackAsyncContext;